import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity'
import { createReducer, on, Action } from '@ngrx/store'

import * as TableNumbersActions from './table-numbers.actions'
import { TableNumbersEntity } from './table-numbers.models'

export const TABLE_NUMBERS_FEATURE_KEY = 'tableNumbers'

export interface TableNumbersState extends EntityState<TableNumbersEntity> {
  loaded: boolean // has the TableNumbers list been loaded
  error?: string | null // last known error (if any)
}

export interface TableNumbersPartialState {
  readonly [TABLE_NUMBERS_FEATURE_KEY]: TableNumbersState
}

export const tableNumbersAdapter: EntityAdapter<TableNumbersEntity> = createEntityAdapter<TableNumbersEntity>({
  selectId: (tableNumber: TableNumbersEntity) => tableNumber.uuid,
})

export const initialTableNumbersState: TableNumbersState = tableNumbersAdapter.getInitialState({
  // set initial required properties
  loaded: false,
})

const reducer = createReducer(
  initialTableNumbersState,
  on(TableNumbersActions.loadTableNumbers, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(TableNumbersActions.loadTableNumbersSuccess, (state, { tableNumbers }) =>
    tableNumbersAdapter.setAll(tableNumbers, { ...state, loaded: true }),
  ),
)

export function tableNumbersReducer(state: TableNumbersState | undefined, action: Action) {
  return reducer(state, action)
}
